import { DtoAreaGom } from "./DtoAreaGom";

export class DtoCentroCostos {
    ID_CentroCostos: number = 0;
    Codigo_SIGO: string = '';
    Codigo: string = '';
    Descripcion: string = '';
    OT: string = '';
    Area: DtoAreaGom = new DtoAreaGom();
}